import { Injectable } from '@angular/core';
import { iBisAuthService, iBisSecureEditService } from '@dohu/ibis-auth';
import { iBisLanguageService, iBisServerConfig } from '@dohu/ibis-common';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import CustomStore from 'devextreme/data/custom_store';

@Injectable({
  providedIn: 'root'
})
export class ReportAuditEditService extends iBisSecureEditService {
  audit!: CustomStore;
  user!: CustomStore;

  constructor(auth: iBisAuthService, lg: iBisLanguageService, entity: iBisEntityService, config: iBisServerConfig) {
    super(auth, entity, config, lg);
  }

  protected load(): void {
    this.user = this.entity.store(new EntityQuery("UserLoginView").addOrderBy(['u.fullName']), false, 'u_id', this.config.saasServer);
    this.audit = this.entity.store(new EntityQuery('ReportAuditView').addOrderByDesc(['modified']), false, 'id');
  }

  createDefault() {
    return {};
  }
  getById(_id: string, _serverUrl?: string): Promise<any> {
    return Promise.reject('Method not applicable for reports.');
  }
  onRemove(_id: string): Promise<void> {
    return Promise.reject('Method not applicable for reports.');
  }
  onSaveEv(_serverUrl?: string): Promise<any> {
    return Promise.reject('Method not applicable for reports.');
  }
  reset(): void {
    this.model = this.createDefault();
  }
}
